import { UsersOnline as onlinePresenceUsersOnline } from '@repo/studio-online-presence/users-online-indicator'

export const UsersOnline = onlinePresenceUsersOnline
